/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_material";
import { Action as AuthAction } from "api/action_types/authentication";
import { Action as QuoteAction } from "api/action_types/shop_quote";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_material";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { ActionType as QuoteActionType } from "api/action_types/shop_quote";
/// TYPES ///
import { IShopColor } from "api/types/shop_material";
/// URLS ///
import { shop_color_url } from "../../endpoint";
import { url_prefix } from "settings";

export const createShopColor = (color: IShopColor) => {
  return async (dispatch: Dispatch<Action | AuthAction | QuoteAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: QuoteActionType.SHOP_QUOTE_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${shop_color_url}/`;

    try {
      const { data } = await axios.post(url, color, config);

      dispatch({
        type: ActionType.CREATE_SHOP_COLOR,
        color: data
      });

      dispatch({
        type: QuoteActionType.SHOP_QUOTE_ACTION_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_MATERIAL_ERROR,
          error: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
